class CountdownTimer {
  constructor() {
    this.countdownElements = document.querySelectorAll('.count_time_delivery strong');
    this.init();
  }

  init() {
    if (this.countdownElements.length === 0) return;
    
    // Configurar el countdown de 3 horas
    this.setDeadline();
    
    // Iniciar el countdown
    this.startCountdown();
  }

  setDeadline() {
    const now = new Date();
    const deadline = new Date();
    
    // Configurar para 3 horas desde ahora
    deadline.setTime(now.getTime() + (3 * 60 * 60 * 1000));
    
    this.deadline = deadline;
  }

  startCountdown() {
    const updateTimer = () => {
      const now = new Date().getTime();
      const distance = this.deadline.getTime() - now;

      if (distance < 0) {
        // Si se acabó el tiempo, reiniciar para otras 3 horas
        this.setDeadline();
        return;
      }

      // Calcular horas, minutos y segundos
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // Formatear el tiempo con ceros a la izquierda
      const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

      // Actualizar todos los elementos countdown
      this.countdownElements.forEach(element => {
        element.textContent = formattedTime;
      });
    };

    // Ejecutar inmediatamente
    updateTimer();
    
    // Actualizar cada segundo
    setInterval(updateTimer, 1000);
  }
}

// Inicializar el countdown cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', () => {
  new CountdownTimer();
});

// También inicializar si el script se carga después del DOM
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CountdownTimer();
  });
} else {
  new CountdownTimer();
} 